const AppConstants = {
    AppGiganautWorkerIosId: "036d55ba-9735-41ee-9c98-e0e9514bd131",
    AppGiganautWorkerAndroidId: "ce8b457e-82e3-45fe-aca0-eaefbf3aff17",
    AppGiganautWebPortalId: "b47a3310-e6b0-4d80-9514-47d520f3e26d",
   
  };
  export default AppConstants;
  